import { Text } from '@mantine/core'
import { CreativeForm } from 'components/creatives'
import { useAppTranslation } from 'hooks/useTranslation'

export const CreateCreative = () => {
  const { t } = useAppTranslation()

  return (
    <div>
      <Text size="xl" fw="bold" mb="lg">
        {t('creatives.create_creative')}
      </Text>
      <CreativeForm isNew />
    </div>
  )
}